export const LOAD_ABTEILUNGEN = 'loadAbteilungen';
export const LOAD_USERS = 'loadUsers';
export const LOAD_DOKUMENTTYPEN = 'load_dokumenttypen';
